import { __assign, __rest } from "tslib";
import * as React from 'react';
import { useStaticsFromCdn } from '../../hooks/useStaticsFromCdn';
import { Loader } from '../Loader';
var Checkout = function (_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    var module = useStaticsFromCdn({
        httpClient: props.httpClient,
        bundleType: "checkout" /* BUNDLE_TYPE.CHECKOUT */,
        onError: props.onInitError,
        flowType: 'checkout',
        locale: props.locale,
    });
    var renderLoader = props.renderLoader;
    if (module) {
        var CheckoutForm = module.Checkout;
        Checkout.Summary.Row = CheckoutForm.Summary.Row;
        return (React.createElement(CheckoutForm, __assign({}, props),
            React.createElement(CheckoutForm.PaymentMethod, null),
            React.createElement(CheckoutForm.Summary, __assign({}, props.summaryProps))));
    }
    return renderLoader ? renderLoader() : React.createElement(Loader, null);
};
function Summary() {
    return React.createElement("div", null);
}
Summary.Row = function () { return React.createElement("div", null); };
Checkout.Summary = Summary;
export default Checkout;
//# sourceMappingURL=Checkout.js.map